import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UserReviewsImageDialogComponent } from '@features/user/components/user-reviews-image-dialog/user-reviews-image-dialog.component';
import { UserPendingProductReview } from '@features/user/interfaces/user-product-review.interface';
import { UserReviewProductService } from '@features/user/services/user-review-product';
import {
  faChevronDown,
  faFileImage,
  faPlus,
  faSpinner,
  faStar,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons';
import { DialogService } from 'primeng/dynamicdialog';
import { LayoutService } from 'src/app/layout/services/layout.service';

@Component({
  selector: 'fc-user-review-product-pending',
  templateUrl: './user-review-product-pending.component.html',
  styleUrls: ['./user-review-product-pending.component.css'],
})
export class UserReviewProductPendingComponent implements OnInit {
  faStar = faStar;
  faPlus = faPlus;
  faTimesCircle = faTimesCircle;
  faSpinner = faSpinner;
  faChevronDown = faChevronDown;
  faImg = faFileImage;

  shopDefaultImg = 'assets/images/shop/shop-logo.png';
  productDefaultImg: string = 'assets/images/product/default-product.png';
  currentPage = 0;

  totalItems = 0;
  reviews: UserPendingProductReview[] = [];

  formHandler: any = {
    toggle: [],
    changeRating: [],
    form: [],
    error: [],
    imageUrls: [],
    loading: [],
  };

  hideLoadMore = true;
  loadMoreLoading = false;

  constructor(
    private userReviewProductService: UserReviewProductService,
    private sanitizer: DomSanitizer,
    private dialogService: DialogService,
    private layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    this.loadReview();
  }

  loadReview() {
    this.currentPage += 1;
    this.loadMoreLoading = true;
    this.userReviewProductService
      .getPendingReview(13, this.currentPage)
      .subscribe(
        (data) => {
          this.totalItems = data.totalItems;
          data.reviews.map((rv: any) => {
            this.reviews.push(rv);
            let form: any = [];
            let error: any = [];
            let url: any = [];
            let toggle: any = [];
            let changeRating: any = [];
            let loading: any = [];
            rv.pending_reviews.forEach((prv: any) => {
              form.push({
                review: null,
                rate: 5,
                image_1: null,
                image_2: null,
                image_3: null,
                image_4: null,
                order_line_id: prv.id,
              });
              url.push({
                image_1: null,
                image_2: null,
                image_3: null,
                image_4: null,
              });
              error.push({
                message: null,
                emptyRate: false,
                emptyReview: false,
              });
              toggle.push(false);
              changeRating.push(false);
              loading.push(false);
            });
            this.formHandler.toggle.push(toggle);
            this.formHandler.changeRating.push(changeRating);
            this.formHandler.form.push(form);
            this.formHandler.error.push(error);
            this.formHandler.imageUrls.push(url);
            this.formHandler.loading.push(loading);
          });
          this.loadMoreLoading = false;
          this.hideLoadMore = data.totalItems <= this.reviews.length;
        },
        (error) => {
          this.loadMoreLoading = false;
        }
      );
  }

  handleShopImgError() {
    this.shopDefaultImg = 'assets/images/shop/shop-logo.png';
  }
  handleProductImgError() {
    this.productDefaultImg = 'assets/images/product/default-product.png';
  }

  // rvi = review index; pri = product index;
  toggleAddReview(rvi: any, pri: any) {
    if (this.formHandler.toggle[rvi][pri] == true) {
      this.formHandler.toggle.forEach((rv: any) => {
        for (let pi in rv) {
          rv[pi] = false;
        }
      });
    } else {
      this.formHandler.toggle.forEach((rv: any) => {
        for (let pi in rv) {
          rv[pi] = false;
        }
      });
      this.formHandler.toggle[rvi][pri] = true;
    }
  }

  giveRating(rating: any, rvi: any, pri: any) {
    this.formHandler.form[rvi][pri].rate = rating;
    this.formHandler.changeRating[rvi][pri] = false;
    this.formHandler.error[rvi][pri].emptyRate = false;
  }

  onAddReviewImage(event: any, rvi: any, pri: any, imageNum: any) {
    if (event.target.files && event.target.files[0]) {
      let files = event.target.files[0];
      if (imageNum == 1) this.formHandler.form[rvi][pri].image_1 = files;
      if (imageNum == 2) this.formHandler.form[rvi][pri].image_2 = files;
      if (imageNum == 3) this.formHandler.form[rvi][pri].image_3 = files;
      if (imageNum == 4) this.formHandler.form[rvi][pri].image_4 = files;
      this.convertFileToImage(files, rvi, pri, imageNum);
    }
  }

  openReviewsImage(event: any, rvi: any, pri: any, imageNum: any) {
    let style = {};
    if (this.layoutService.isMobile$.value) {
      style = {
        'max-height': '100%',
        width: '100vh',
        height: '100vh',
        overflow: 'hidden',
      };
    } else {
      style = {
        width: '500px',
        height: '600px',
        'border-radius': '1rem',
        overflow: 'hidden',
      };
    }
    const ref = this.dialogService.open(UserReviewsImageDialogComponent, {
      dismissableMask: true,
      closable: true,
      showHeader: false,
      contentStyle: {
        padding: '0',
      },
      style: style,
    });
    ref.onClose.subscribe((image: any) => {
      console.log(image);
      if (event.target.files && event.target.files[0]) {
        let files = event.target.files[0];
        if (imageNum == 1) this.formHandler.form[rvi][pri].image_1 = files;
        if (imageNum == 2) this.formHandler.form[rvi][pri].image_2 = files;
        if (imageNum == 3) this.formHandler.form[rvi][pri].image_3 = files;
        if (imageNum == 4) this.formHandler.form[rvi][pri].image_4 = files;
        this.convertFileToImage(files, rvi, pri, imageNum);
      }
    });
  }

  convertFileToImage(file: any, rvi: any, pri: any, imageNum: any) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      if (imageNum == 1)
        this.formHandler.imageUrls[rvi][pri].image_1 = reader.result;
      if (imageNum == 2)
        this.formHandler.imageUrls[rvi][pri].image_2 = reader.result;
      if (imageNum == 3)
        this.formHandler.imageUrls[rvi][pri].image_3 = reader.result;
      if (imageNum == 4)
        this.formHandler.imageUrls[rvi][pri].image_4 = reader.result;
    };
  }

  getReviewImage(rvi: any, pri: any, imageNum: any) {
    if (imageNum == 1 && this.formHandler.form[rvi][pri].image_1)
      return this.getSanitizeUrl(this.formHandler.imageUrls[rvi][pri].image_1);
    if (imageNum == 2 && this.formHandler.form[rvi][pri].image_2)
      return this.getSanitizeUrl(this.formHandler.imageUrls[rvi][pri].image_2);
    if (imageNum == 3 && this.formHandler.form[rvi][pri].image_3)
      return this.getSanitizeUrl(this.formHandler.imageUrls[rvi][pri].image_3);
    if (imageNum == 4 && this.formHandler.form[rvi][pri].image_4)
      return this.getSanitizeUrl(this.formHandler.imageUrls[rvi][pri].image_4);
    return null;
  }

  deleteReviewImage(rvi: any, pri: any, imageNum: any) {
    if (imageNum == 1 && this.formHandler.form[rvi][pri].image_1) {
      this.formHandler.imageUrls[rvi][pri].image_1 = null;
      this.formHandler.form[rvi][pri].image_1 = null;
    }
    if (imageNum == 2 && this.formHandler.form[rvi][pri].image_2) {
      this.formHandler.imageUrls[rvi][pri].image_2 = null;
      this.formHandler.form[rvi][pri].image_2 = null;
    }
    if (imageNum == 3 && this.formHandler.form[rvi][pri].image_3) {
      this.formHandler.imageUrls[rvi][pri].image_3 = null;
      this.formHandler.form[rvi][pri].image_3 = null;
    }
    if (imageNum == 4 && this.formHandler.form[rvi][pri].image_4) {
      this.formHandler.imageUrls[rvi][pri].image_4 = null;
      this.formHandler.form[rvi][pri].image_4 = null;
    }
  }
  getSanitizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  inputReview(rvi: any, pri: any, event: any) {
    this.formHandler.form[rvi][pri].review = event.value;
    this.formHandler.error[rvi][pri].emptyReview = false;
  }

  submitReview(rvi: any, pri: any) {
    let isInvalid = false;
    if (this.formHandler.form[rvi][pri].rate == null) {
      this.formHandler.error[rvi][pri].emptyRate = true;
      isInvalid = true;
    }
    if (this.formHandler.form[rvi][pri].review == null) {
      this.formHandler.error[rvi][pri].emptyReview = true;
      isInvalid = true;
    }
    if (!isInvalid) {
      this.formHandler.loading[rvi][pri] = true;
      let form = this.formHandler.form[rvi][pri];
      let formData = new FormData();
      if (form.review) formData.append('review', form.review);
      if (form.rate) formData.append('rate', form.rate);
      if (form.image_1) formData.append('image_1', form.image_1);
      if (form.image_2) formData.append('image_2', form.image_2);
      if (form.image_3) formData.append('image_3', form.image_3);
      if (form.image_4) formData.append('image_4', form.image_4);
      if (form.order_line_id)
        formData.append('order_line_id', form.order_line_id);
      this.userReviewProductService.addProductreview(formData).subscribe(
        (res) => {
          this.reviews.forEach(
            (rv) =>
              (rv.pending_reviews = rv.pending_reviews.filter(
                (prv) => prv.id != form.order_line_id
              ))
          );
          this.formHandler.form[rvi].splice(pri, 1);
          this.formHandler.toggle[rvi].splice(pri, 1);
          this.formHandler.error[rvi].splice(pri, 1);
          this.formHandler.changeRating[rvi].splice(pri, 1);
          this.formHandler.imageUrls[rvi].splice(pri, 1);
          this.formHandler.loading[rvi].splice(pri, 1);
          if (this.reviews[rvi].pending_reviews.length < 1) {
            this.reviews.splice(rvi, 1);
            this.formHandler.form.splice(rvi, 1);
            this.formHandler.toggle.splice(rvi, 1);
            this.formHandler.error.splice(rvi, 1);
            this.formHandler.changeRating.splice(rvi, 1);
            this.formHandler.imageUrls.splice(rvi, 1);
            this.formHandler.loading.splice(rvi, 1);
          }
        },
        (error) => {}
      );
    }
  }
}
